export default "__VITE_ASSET__DrzDhRtZ__"